<ion-content class="ion-padding">
    <div class="content">
        <ion-label><b>{{ 'headEvaluation.editFinalAverage' | translate }}</b></ion-label>
        <ion-label>{{ 'headEvaluation.colaboratorFinalAverage' | translate }}: <b>{{ userEvaluation.initialFinalEvaluation }}</b>
        </ion-label>
        <ion-label>{{ 'headEvaluation.newColaboratorFinalAverage' | translate }}:</ion-label>
        <p (click)="dismiss()">x</p>
    </div>
    <ion-item class="input-average">
        <input type="number" max="999" [(ngModel)]="this.finalEvaluation" (input)="checkMaxValue($event)"/>
        <span class="bp-edit"></span>
    </ion-item>
</ion-content>
<ion-footer>
    <ion-item>
        <ion-button mode="ios" size="default" fill="outline" color="danger" slot="start" (click)="dismiss()">
            {{ 'generic.cancel' | translate }}
        </ion-button>
        <ion-button mode="ios" size="default" color="primary" slot="end" (click)="setHeadFinalAverage()">
            {{ 'generic.confirm' | translate }}
        </ion-button>
    </ion-item>
</ion-footer>